import { ApiConnector } from './api.connector';
import type {
  IVehicleCity,
  IVehicleModel
} from './api.types/vehicles.api-types';

class VehiclesApi extends ApiConnector {
  getCities(): Promise<IVehicleCity[]> {
    return this.call<undefined, IVehicleCity[]>({
      path: 'vehicles/cities',
      method: 'get'
    });
  }

  getModels(cityId: string): Promise<IVehicleModel[]> {
    return this.call<{ cityId: string }, IVehicleModel[]>({
      path: 'vehicles/models',
      method: 'get',
      params: { cityId }
    });
  }
}

export const vehiclesApi = new VehiclesApi();
